import { createContext, ReactNode, useContext } from 'react';

import { TMobileSignupStage } from '../screens/types';

type TMobileSignupNavContext = {
  goNext: () => void;
  stage: TMobileSignupStage;
};

const MobileSignupNavContext = createContext<TMobileSignupNavContext | null>(
  null,
);

export const MobileSignupNavProvider = ({
  goNext,
  stage,
  children,
}: TMobileSignupNavContext & { children: ReactNode }) => (
  <MobileSignupNavContext.Provider value={{ goNext, stage }}>
    {children}
  </MobileSignupNavContext.Provider>
);

export const useMobileSignupNavContext = (): TMobileSignupNavContext => {
  const context = useContext(MobileSignupNavContext);
  if (!context) {
    throw new Error(
      'useMobileSignupNavContext must be used within a MobileSignupNavProvider',
    );
  }
  return context;
};
